module.exports = {
  messages: {
    BUTTON_SHOW_MORE: 'Mehr',
    CAREER_GUIDANCE_DETAILS_PAGE_MODERN_1:
      'Löst Du Aufgaben gern selbst und ohne Vorgaben, was Prozesse und Methoden angeht? Dann fühlst Du Dich in einer modernen Unternehmenskultur sicher wohl.',
    CAREER_GUIDANCE_DETAILS_PAGE_TRADITIONAL_1:
      'In einer traditionellen Unternehmenskultur fühlst Du Dich wohl, wenn Du klar definierte Regeln und Strukturen magst, die für Stabilität, Ordnung und Transparenz sorgen.',
    COMMBOX_AUDIENCE_PRIVATE: 'Privat (nur XING Kontakte)',
    COMMBOX_AUDIENCE_PRIVATE_DESC: 'Dein Beitrag kann nicht geteilt werden.',
    COMMBOX_AUDIENCE_PRIVATE_SELECTED: 'Privat',
    COMMBOX_AUDIENCE_PUBLIC: 'Öffentlich',
    COMMBOX_AUDIENCE_PUBLIC_DESC: 'Jeder kann Deinen Beitrag sehen und teilen.',
    COMPANY_BENEFIT_ACCESSIBILITY: 'Barrierefreiheit',
    COMPANY_BENEFIT_CANTEEN: 'Kantine',
    COMPANY_BENEFIT_CAR_PARK: 'Parkplatz',
    COMPANY_BENEFIT_CHILDCARE: 'Kinderbetreuung',
    COMPANY_BENEFIT_COMPANY_CAR: 'Firmenwagen',
    COMPANY_BENEFIT_COMPANY_DOCTOR: 'Betriebsarzt',
    COMPANY_BENEFIT_COMPANY_PENSION: 'Betriebliche Altersvorsorge',
    COMPANY_BENEFIT_CONVENIENT_TRANSPORT_LINKS: 'Günstige Anbindung',
    COMPANY_BENEFIT_DISCOUNTS_SPECIAL_OFFERS: 'Vorteile für Mitarbeitende',
    COMPANY_BENEFIT_DOGS_WELCOME: 'Hunde willkommen',
    COMPANY_BENEFIT_EVENTS_FOR_EMPLOYEES: 'Veranstaltungen',
    COMPANY_BENEFIT_FLEXITIME: 'Flexible Arbeitszeiten',
    COMPANY_BENEFIT_HEALTH_IN_THE_WORKPLACE: 'Gesundheitsmaßnahmen',
    COMPANY_BENEFIT_HOME_OFFICE: 'Home-Office',
    COMPANY_BENEFIT_MOBILE_DEVICE: 'Smartphone',
    COMPANY_BENEFIT_PRIVATE_INTERNET_USE: 'Privat das Internet nutzen',
    COMPANY_BENEFIT_PROFIT_SHARING: 'Gewinnbeteiligung',
    COMPANY_BENEFIT_RESTAURANT_TICKETS: 'Restaurant-Tickets',
    COMPANY_BENEFIT_TRAINING: 'Training',
    DUPLICATE_SHARE_ERROR:
      'Du hast dies schon geteilt – Dein Netzwerk ist also bestens informiert.',
    JOB_POSTING_APPLY_EXTERNAL_URL: 'Zur Arbeitgeber-Website',
    JOBS_CREATE_SEARCH_ALERT: 'Suchauftrag erstellen',
    JOBS_DETAIL_MENU_BUTTON_A11Y: 'Option auswählen',
    JOBS_ERROR_SOMETHING_WENT_WRONG:
      'Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.',
    JOBS_FIND_JOBS_LINK: 'Jobs finden',
    JOBS_HEADER_SALARY_EMPLOYER_PROVIDED: '(Unternehmensangabe)',
    JOBS_HIGHLIGHT_ACTIVELY_RECRUITING: 'Aktiv auf der Suche',
    JOBS_HIGHLIGHT_EARLY_APPLICANT: 'Zu den Ersten gehören',
    JOBS_HIGHLIGHT_INSTANT_XING_APPLY: 'Ohne Dokumente bewerben',
    JOBS_HIGHLIGHT_LAST_CHANCE_TO_APPLY: 'Noch schnell bewerben',
    JOBS_HYBRID_TAG: 'Hybrid',
    JOBS_JOB_DETAIL_CREATE_SEARCH_ALERT_CTA: 'Suchauftrag erstellen',
    JOBS_JOB_DETAIL_CREATE_SEARCH_ALERT_KEYWORDS:
      'Alle neuen Jobs als {keywords} per E-Mail bekommen:',
    JOBS_JOB_DETAIL_CREATE_SEARCH_ALERT_LOCATION:
      'Wir benachrichtigen Dich gern über ähnliche Jobs in {location}:',
    JOBS_JOB_DETAIL_SALARY_ESTIMATED_AVERAGE_LEGEND:
      'Geschätztes Durchschnitts-Gehalt für vergleichbare Positionen',
    JOBS_JOB_DETAIL_SALARY_ESTIMATED_HEADLINE: 'Gehalts-Prognose',
    JOBS_JOB_DETAIL_SALARY_ESTIMATED_INFO: 'Wie wird das berechnet?',
    JOBS_JOB_DETAIL_SALARY_ESTIMATED_INFO_CONTENT:
      'Die angezeigten Gehaltsdaten sind eine Schätzung der Bruttojahresgehälter in vergleichbaren Vollzeit-Positionen inkl. möglicher variabler Anteile. Die Schätzung ist unverbindlich. Grundlage sind statistische Verfahren, die mit anonymisierten XING Nutzerdaten und Marktdaten erstellt werden. Das Gehalts-Spektrum hängt von folgenden Variablen ab: Titel des Stellenangebots, Standort des Arbeitgebers, Unternehmensgröße, Branche, Karrierelevel vergleichbarer Positionen (soweit XING hierzu Daten besitzt). Die Gehaltsspanne soll die üblichsten Gehaltsdaten darstellen. Ausreißer nach oben oder unten werden nicht berücksichtigt. Abweichungen von tatsächlich von Inserenten gezahlten Gehältern sind möglich.',
    JOBS_JOB_DETAIL_SALARY_ESTIMATED_RANGE_LEGEND:
      'Geschätzte Gehalts-Spanne für vergleichbare Positionen',
    JOBS_JOB_DETAIL_SALARY_EXACT_BODY: 'Angabe des Arbeitgebers',
    JOBS_JOB_DETAIL_SALARY_EXACT_HEADLINE: 'Gehalt',
    JOBS_JOB_DETAIL_SALARY_MODULE_A11Y_RANGE:
      'Die Gehaltsspanne liegt zwischen {minimum} und {maximum}',
    JOBS_JOB_DETAIL_SALARY_MODULE_A11Y_RANGE_WITH_MEDIAN:
      'Das Gehalt für diese Position liegt zwischen {minimum} und {maximum}, mit einem Durchschnittsgehalt von {median}',
    JOBS_JOB_DETAIL_SALARY_RANGE_BODY: 'Angabe des Arbeitgebers ',
    JOBS_JOB_DETAIL_SALARY_RANGE_HEADLINE: 'Gehaltsspanne',
    JOBS_JOB_DETAILS_ABOUT_COMPANY_HEADER: 'Unternehmens-Details',
    JOBS_JOB_DETAILS_APPLY: 'Bewerben',
    JOBS_JOB_DETAILS_APPLY_MAIL_BODY:
      'Sehr geehrte Damen und Herren,\n\nich bewerbe mich um die von Ihnen auf XING ausgeschriebene Position als {posting_function}.\n\nMit freundlichen Grüßen\n{name}',
    JOBS_JOB_DETAILS_APPLY_MAIL_SUBJECT: 'Bewerbung: {posting_function}',
    JOBS_JOB_DETAILS_APPLY_MAIL_SUBJECT_WITH_CODE:
      'Bewerbung: {posting_function} | Referenz: {posting_job_code}',
    JOBS_JOB_DETAILS_CANCEL: 'Abbrechen',
    JOBS_JOB_DETAILS_COMPANY_ALL_JOBS: 'Alle Stellenangebote',
    JOBS_JOB_DETAILS_COMPANY_CONTACTS_MODULE_SUBTITLE:
      'Frag doch einfach Deine Kontakte:',
    JOBS_JOB_DETAILS_COMPANY_CONTACTS_MODULE_TITLE: 'Ein guter Arbeitgeber?',
    JOBS_JOB_DETAILS_COMPANY_CONTACTS_SHOW_ALL: 'Alle Mitarbeitenden',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_COMPASS_LEGEND_LEFT:
      '<top>Traditionelle</top>Kultur',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_COMPASS_LEGEND_RIGHT:
      '<top>Moderne</top>Kultur',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_BALANCED:
      'Der Branchen-Durchschnitt liegt recht ausgeglichen zwischen traditionell und modern.',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_IN_LINE:
      'Dies stimmt ungefähr mit dem Branchen-Durchschnitt überein.',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_NOT_BALANCED:
      'Der Branchen-Durchschnitt {verb} übrigens {industryWeight} in Richtung {cultureBinaryIndustry}',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_VERB_1: 'tendiert',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_VERB_2: 'tendiert',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_VERB_3: 'geht',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_VERB_4: 'geht',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_WEIGHT_LIGHT:
      'leicht',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_WEIGHT_STRONG:
      'deutlich',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_INTRO:
      '{totalCultureReviews} Mitarbeitende haben abgestimmt: Sie bewerten die Unternehmenskultur bei {companyName}',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_PROFILE_BALANCED:
      ' als ausgeglichen zwischen traditionell und modern.',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_PROFILE_BINARY:
      ' als {profileWeight} {cultureBinaryProfile}.',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_PROFILE_WEIGHT_LIGHT: 'eher',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_PROFILE_WEIGHT_STRONG: 'sehr',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_VALUE_MODERN: 'modern',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_INFO_COMPASS_VALUE_TRADITIONAL:
      'traditionell',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_LEGEND_INDUSTRY: 'Branchen-Durchschnitt',
    JOBS_JOB_DETAILS_COMPANY_CULTURE_TITLE: 'Unternehmenskultur',
    JOBS_JOB_DETAILS_COMPANY_MODULE_CARD_LINK_LABEL:
      'Klicke zum Öffnen des Unternehmensprofils',
    JOBS_JOB_DETAILS_COMPANY_MODULE_FOLLOW_A11Y_LABEL:
      'Diesem Arbeitgeber folgen',
    JOBS_JOB_DETAILS_COMPANY_MODULE_UNFOLLOW_A11Y_LABEL:
      'Arbeitgeber nicht mehr folgen',
    JOBS_JOB_DETAILS_CULTURE_ASSESSMENT_MODULE_CARD_LINK_LABEL:
      'Klicke hier, wenn du sehen willst, ob die Unternehmenskultur zu dir passt',
    JOBS_JOB_DETAILS_DEFAULT_ERROR:
      'Das hat nicht geklappt. Versuch es bitte erneut.',
    JOBS_JOB_DETAILS_DESCRIPTION: 'Beschreibung',
    JOBS_JOB_DETAILS_DESCRIPTION_COMPANY_WEB_ICON_LINK:
      'Zur Unternehmenswebsite',
    JOBS_JOB_DETAILS_DESCRIPTION_FACEBOOK_ICON_LINK:
      'Zum Unternehmensprofil auf Facebook',
    JOBS_JOB_DETAILS_DESCRIPTION_HEADLINE: 'Über diesen Job',
    JOBS_JOB_DETAILS_DESCRIPTION_INSTAGRAM_ICON_LINK:
      'Zum Unternehmensprofil auf Instagram',
    JOBS_JOB_DETAILS_DESCRIPTION_KUNUNU_ICON_LINK:
      'Zum Unternehmensprofil auf kununu',
    JOBS_JOB_DETAILS_DESCRIPTION_PINTEREST_ICON_LINK:
      'Zum Unternehmensprofil auf Pinterest',
    JOBS_JOB_DETAILS_DESCRIPTION_SHOW_LESS: 'Weniger anzeigen',
    JOBS_JOB_DETAILS_DESCRIPTION_SHOW_MORE: 'Mehr Details',
    JOBS_JOB_DETAILS_DESCRIPTION_TIKTOK_ICON_LINK:
      'Zum Unternehmensprofil auf TikTok',
    JOBS_JOB_DETAILS_DESCRIPTION_TWITTER_ICON_LINK:
      'Zum Unternehmensprofil auf X',
    JOBS_JOB_DETAILS_DESCRIPTION_XING_ICON_LINK: 'Zur XING Unternehmensseite',
    JOBS_JOB_DETAILS_DESCRIPTION_YOUTUBE_ICON_LINK:
      'Zum YouTube-Kanal des Unternehmens',
    JOBS_JOB_DETAILS_EMPLOYEE_REVIEW: 'Basierend auf {ratingCount} Bewertungen',
    JOBS_JOB_DETAILS_EMPLOYEE_REVIEWS_TITLE: 'Gesamtbewertung',
    JOBS_JOB_DETAILS_EMPLOYER_SHOWCASE_VIDEO: 'Arbeitgeber-Video',
    JOBS_JOB_DETAILS_EXTERNAL_JOB_BANNER_BODY:
      'Dieser Job existiert nur außerhalb von XING. Wir bringen Dich gern hin.',
    JOBS_JOB_DETAILS_EXTERNAL_JOB_BANNER_CTA: 'Job ansehen',
    JOBS_JOB_DETAILS_EXTERNAL_JOB_BANNER_TITLE: 'Du möchtest mehr erfahren?',
    JOBS_JOB_DETAILS_EXTERNAL_URL_DESCRIPTION_NO_CONSENT_HEADLINE:
      'Dieses Stellenangebot kommt direkt von einer externen Webseite – und Du hast solche Inhalte bei XING in Deinen Einstellungen (unter "Privatsphäre > Tracking") deaktivert.',
    JOBS_JOB_DETAILS_EXTERNAL_URL_DESCRIPTION_NO_CONSENT_LINK:
      'Du kannst Dir aber gern {link}.',
    JOBS_JOB_DETAILS_EXTERNAL_URL_DESCRIPTION_NO_CONSENT_LINK_CONTENT:
      'den Job direkt auf der Website ansehen',
    JOBS_JOB_DETAILS_FACTS_A11Y:
      'Das passt zu Deinen Job-Wünschen: {variable_1} ',
    JOBS_JOB_DETAILS_FOLLOW_COMPANY: 'Folgen',
    JOBS_JOB_DETAILS_FOLLOW_COMPANY_NOTIFICATION_A11Y:
      '<b>Du folgst jetzt diesem Unternehmen.</b> Du findest es im Bereich „Insights“ in der Rubrik „Unternehmen“.',
    JOBS_JOB_DETAILS_FOLLOW_COMPANY_NOTIFICATION_ERROR_A11Y:
      'Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.',
    JOBS_JOB_DETAILS_HR_CONTACT_MODULE_CARD_LINK_LABEL:
      'Klicke zum Öffnen der Profilseite der Kontaktperson',
    JOBS_JOB_DETAILS_JOB_CONTACT_CURRENT_COMPANY: 'Arbeitet bei {company}',
    JOBS_JOB_DETAILS_JOB_CONTACT_PREVIOUS_COMPANY:
      'Hat bei {company} gearbeitet',
    JOBS_JOB_DETAILS_KUNUNU_BENEFITS: 'Vorteile für Mitarbeitende',
    JOBS_JOB_DETAILS_KUNUNU_BENEFITS_SHOW_ALL: 'Alle Vorteile anzeigen',
    JOBS_JOB_DETAILS_KUNUNU_BENEFITS_SHOW_LESS: 'Weniger Vorteile anzeigen',
    JOBS_JOB_DETAILS_KUNUNU_CULTURE: 'Mehr Infos anzeigen',
    JOBS_JOB_DETAILS_KUNUNU_RATED_BY: 'Von {rating} Mitarbeitenden bewertet',
    JOBS_JOB_DETAILS_KUNUNU_TITLE: 'Bewertung von Mitarbeitenden',
    JOBS_JOB_DETAILS_MANAGE: 'Stellenanzeige verwalten',
    JOBS_JOB_DETAILS_MESSAGE_HR_CONTACT: 'Nachricht schreiben',
    JOBS_JOB_DETAILS_NEXT_JOB: 'Nächster Job',
    JOBS_JOB_DETAILS_NEXT_SIMILAR_JOB: 'Nächster ähnlicher Job',
    JOBS_JOB_DETAILS_PREVIOUS_JOB: 'Vorheriger Job',
    JOBS_JOB_DETAILS_PREVIOUSLY_APPLIED_CONFIRMATION:
      'Du hast Dich am {date} für diesen Job beworben.',
    JOBS_JOB_DETAILS_REPORT_JOB: 'Stellenangebot melden',
    JOBS_JOB_DETAILS_REPORT_JOB_ADD_COMMENT: 'Kommentar hinzufügen (optional)',
    JOBS_JOB_DETAILS_REPORT_JOB_BUTTON: 'Melden',
    JOBS_JOB_DETAILS_REPORT_JOB_CAREER_LEVEL: 'Falsche Karriere-Stufe',
    JOBS_JOB_DETAILS_REPORT_JOB_COMMENT_PLACEHOLDER:
      'Bitte beschreibe den Grund Deiner Meldung.',
    JOBS_JOB_DETAILS_REPORT_JOB_COMPANY_NAME: 'Falscher Unternehmens-Name',
    JOBS_JOB_DETAILS_REPORT_JOB_DESCRIPTION:
      'Wenn Du unangemessene oder verdächtige Stellenangebote meldest, können wir die Qualität von XING Jobs besser sichern.',
    JOBS_JOB_DETAILS_REPORT_JOB_EMPLOYMENT_TYPE: 'Falsche Beschäftigungsart',
    JOBS_JOB_DETAILS_REPORT_JOB_ILLEGAL_CONTENT: 'Illegaler Inhalt',
    JOBS_JOB_DETAILS_REPORT_JOB_LOCATION: 'Falscher Ort',
    JOBS_JOB_DETAILS_REPORT_JOB_NO_JOB_AD: 'Keine Job-Anzeige',
    JOBS_JOB_DETAILS_REPORT_JOB_OTHER: 'Andere Inhalte',
    JOBS_JOB_DETAILS_REPORT_JOB_TITLE: 'Stellenangebot melden',
    JOBS_JOB_DETAILS_REPORT_JOB_WRONG_INFORMATION:
      'Falscher Inhalt (zutreffende Inhalte bitte auswählen)',
    JOBS_JOB_DETAILS_REPORTED_JOB: 'Stellenanzeige gemeldet!',
    JOBS_JOB_DETAILS_SAVE_JOB_NOTIFICATION_A11Y:
      '<b>Du hast Dir diesen Job gemerkt</b> und wir haben ihn der entsprechenden Liste hinzugefügt.',
    JOBS_JOB_DETAILS_SAVE_JOB_NOTIFICATION_ERROR_A11Y:
      'Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.',
    JOBS_JOB_DETAILS_SE_DEFAULT_PAGETITLE: 'Deine Job-Suche',
    JOBS_JOB_DETAILS_SE_DEFAULT_PAGETITLE_SUFFIX: 'XING Suche',
    JOBS_JOB_DETAILS_SEO_META_DESCRIPTION_TAG_POSTING_DETAIL:
      "Bewirb Dich als ''{function}'' bei {company_name} in {city}. Branche: {industry} / Beschäftigungsart: {job_type} / Karriere-Stufe: {level} / Veröffentlicht am: {date}",
    JOBS_JOB_DETAILS_SEO_TITLE_TAG_LOGGED_IN: 'Job: {job_title}',
    JOBS_JOB_DETAILS_SEO_TITLE_TAG_LOGGED_OUT: '{job_title} in {work_location}',
    JOBS_JOB_DETAILS_SHARE_JOB: 'Job teilen',
    JOBS_JOB_DETAILS_SIMILAR_JOBS_HEADLINE: 'Ähnliche Jobs',
    JOBS_JOB_DETAILS_TEMPLATE_DATA_DESCRIPTION_VIDEO_NO_TRACKING_CONSENT_LINK:
      'Video ansehen',
    JOBS_JOB_DETAILS_TEMPLATE_DATA_DESCRIPTION_VIDEO_NO_TRACKING_CONSENT_MESSAGE:
      'Dieses Video kommt von einer externen Webseite. Du hast solche Inhalte bei XING in Deinen Einstellungen (unter "Privatsphäre > Tracking") deaktiviert. ',
    JOBS_JOB_DETAILS_TITLEBAR_SUFFIX: 'XING Jobs',
    JOBS_JOB_DETAILS_TOPBAR_TITLE: 'Details',
    JOBS_JOB_DETAILS_UNFOLLOW_COMPANY: 'Nicht mehr folgen',
    JOBS_JOB_DETAILS_UNFOLLOW_COMPANY_NOTIFICATION_A11Y:
      '<b>Du folgst diesem Unternehmen nicht mehr.</b> Es wurde aus dem Bereich „Insights“ in der Rubrik „Unternehmen“ entfernt.',
    JOBS_JOB_DETAILS_UNFOLLOW_COMPANY_NOTIFICATION_ERROR_A11Y:
      'Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.',
    JOBS_JOB_DETAILS_UNSAVE_JOB_NOTIFICATION_A11Y:
      '<b>Du merkst Dir diesen Job jetzt nicht mehr</b> und wir haben ihn von der entsprechenden Liste entfernt.',
    JOBS_JOB_DETAILS_UNSAVE_JOB_NOTIFICATION_ERROR_A11Y:
      'Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.',
    JOBS_JOB_DETAILS_XING_APPLY: 'Einfach bewerben',
    JOBS_JOB_DETAILS_XING_APPLY_DEACTIVATED_ERROR:
      'Dieser Job ist nicht mehr verfügbar – sieh dir stattdessen andere Jobs an.',
    JOBS_JOB_DETAILS_XING_APPLY_TYPE_ERROR:
      'Der Bewerbungs-Weg hat sich geändert. Lade die Job-Seite bitte einmal neu.',
    JOBS_JOB_DETAILS_XING_VERIFIED: 'Verifizierte Job-Anzeige',
    JOBS_JOB_NOT_AVAILABLE_CTA: 'Jetzt Jobs finden',
    JOBS_JOB_NOT_AVAILABLE_HEADLINE: 'Dieses Stellenangebot existiert nicht.',
    JOBS_JOB_NOT_AVAILABLE_SUBLINE:
      'Entdecke andere aktuelle Job-Angebote bei XING.',
    JOBS_JOB_TEASER_SAVE: 'Job merken',
    JOBS_JOB_TEASER_SAVED: 'Gemerkt',
    JOBS_KUNUNU_RATING_A11Y:
      'Die Bewertung dieses Arbeitgebers auf kununu ist: {value} von 5 Sternen',
    JOBS_MATCHING_REASONS_ERROR:
      'Die KI konnte die Details der Stellen-Beschreibung, die zu Deiner Suche passen, leider nicht laden.',
    JOBS_MATCHING_REASONS_LOADING:
      'Suche passende Details in der Job-Beschreibung',
    JOBS_MATCHING_REASONS_TIP_HEADLINE:
      'Sieh, warum ein Job zu Deiner Suche passt',
    JOBS_MATCHING_REASONS_TIP_SUBTITLE: 'KI-Funktion im Beta-Stadium',
    JOBS_MYJOBS_SAVED_SECTION_TITLE: 'Gemerkte Jobs',
    JOBS_NON_REMOTE_TAG: 'Vor Ort',
    JOBS_REMOTE_TAG: 'Remote',
    JOBS_SALARY_XING_ESTIMATED: '(von XING geschätzt)',
    JOBS_SEARCH_JOBS_LINK: 'Alle Ergebnisse',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO: 'Vor 30+ Tagen',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO_A11Y: 'Vor über 30 Tagen veröffentlicht',
    JOBS_TIMESTAMP_JUST_NOW: 'Gerade eben',
    JOBS_TIMESTAMP_JUST_NOW_A11Y: 'Gerade veröffentlicht',
    JOBS_TIMESTAMP_N_DAYS_AGO: 'Vor {number} Tagen',
    JOBS_TIMESTAMP_N_DAYS_AGO_A11Y: 'Vor {number} Tagen veröffentlicht',
    JOBS_TIMESTAMP_N_HOURS_AGO:
      '{number, plural, =1 {Vor 1 Stunde} other {Vor # Stunden}}',
    JOBS_TIMESTAMP_N_HOURS_AGO_A11Y:
      '{number, plural, =1 {Vor einer Stunde veröffentlicht} other {Vor # Stunden veröffentlicht}}',
    JOBS_TIMESTAMP_YESTERDAY: 'Gestern',
    JOBS_TIMESTAMP_YESTERDAY_A11Y: 'Gestern veröffentlicht',
    MESSENGER_SHARE_COMMENT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    MESSENGER_SHARE_MENU_ENTRY: 'Teilen',
    MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL: 'Empfänger:',
    MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER: 'Empfänger eingeben',
    SHARE_BOX_PLACEHOLDER: 'Hier kannst Du Deinen Link kommentieren.',
    SHARE_BOX_SUBMIT_SHARE: 'Teilen',
    SHARE_CANCEL_BUTTON: 'Abbrechen',
    SHARE_CHAT_HINT: 'Die Empfänger erhalten einzelne Nachrichten.',
    SHARE_FEEDBACK_MESSENGER_BUTTON: 'Nachricht ansehen',
    SHARE_FEEDBACK_MESSENGER_MESSAGE: '{item} per XING Nachricht geteilt',
    SHARE_FEEDBACK_POST_LABEL: 'Beitrag',
    SHARE_FEEDBACK_STARTPAGE_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_STARTPAGE_MESSAGE: '{item} auf der Startseite geteilt',
    SHARE_FETCH_ERROR_RETRY: 'Jetzt erneut versuchen',
    SHARE_PREVIEW_ERROR_HEADLINE:
      'Wir können gerade leider keine Vorschau zeigen.',
    SHARE_TO_MESSENGER_EMPTY_STATE:
      'Wir haben leider keinen "{query}" gefunden.',
    SHARE_USER_SUBTEXT_GROUPS: 'In einer Gruppe teilen',
    SHARE_USER_SUBTEXT_MESSAGE: 'Als private Nachricht teilen',
    SHARE_USER_SUBTEXT_STARTPAGE: 'Auf der Startseite teilen',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Noch mal versuchen',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: "Bitte versuch's noch mal.",
    XDS_EMPTYSTATE_ERROR_TITLE: 'Das hat leider nicht geklappt.',
  },
};
